import React from 'react';

const LoanQuoteStep3 = ({onNewQuoteClick}) => {

    return (
            <div className="container confirmation-screen">
            <div className="row justify-content-start">
                <h4>Loan application</h4>
                <p>Your loan application has been successfully submitted.</p>
                <p>Our team will review your request and get back to you shortly.</p>
                <p>We've also sent an acknowledgement of your application to the email address you provided.</p>
                <div className="col">
                    <button className="btn btn-link " onClick={onNewQuoteClick}>New quote</button>
                </div>
            </div>
        </div>
    );
}

export default LoanQuoteStep3;
